import React, { useState } from 'react';
import {Grid, Box, TextField, InputAdornment, IconButton, Button, Link} from '@mui/material';
import './account.css';
import '../../styles/brandingStyles/branding.css';
import forgotPassBanner from '../../assets/userAccount/forgotPassBanner.png';
import lockGreen from '../../assets/userAccount/lockGreen.png';
import { PersonOutline, LockOutlined, VisibilityOutlined, VisibilityOffOutlined, LoginOutlined, AlternateEmailOutlined, PhoneIphoneOutlined} from '@mui/icons-material';
import axios from 'axios';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import CustomAxios from '../../utils/CustomAxios';
import RememberMeIcon from '@mui/icons-material/RememberMe';
export function ForgotPassword(){
    
    const [email, setEmail] = useState('');
    const [resetLinkSent, setResetLinkSent] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        // Add your signup logic here
        console.log('Signup data:', { email});

        e.preventDefault();

        const payload = {
            email: email
        };

        // Send data to the API endpoint using Axios (replace with your actual API endpoint)
        CustomAxios.post(`oasis/forgot_password/`, payload)
          .then(response => {
            // Handle API response as needed
            console.log('API Response:', response);
            setResetLinkSent(true)
            })
            .catch(error => {
                console.error('Error:', error);
            });

    };

    return(
            <Box sx={{ height: {sm:'initial',md:'100vh',width:"100%"} }}>
                <Grid container className='login-bg-primary' sx={{ height: {xs:"100vh",sm:'initial',md:'100%'},padding: {xs:"20px"} }}>
                    <Grid item xs={12} sm={7}  sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <Box component='img' sx={{width: { xs: "70%"}}} src={forgotPassBanner} />
                    </Grid>
                <Grid item xs={12} sm={5} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} className='login-bg-primary'>
                    <Box className='login-bg-primary-mem form' sx={{ mt: { xs: "20px" }}}>
                            { resetLinkSent ?
                            <Box>
                                <Box sx={{mb:4}} className='text-center'>
                                    <Box component='img' sx={{mb:1,width: { xs: "20%"}}}  src={lockGreen} />
                                    <Box sx={{mb:1}} className='fn-h3 fw-600 primary text-center'>Link Sent</Box>
                                    <Box className='pgh text-center'>We have emailed you the Secured code to reset your password </Box>
                                    <Box className='pgh text-center'>உங்கள் கடவுச்சொல்லை மீட்டமைப்பதற்கான பாதுகாப்புக் குறியீட்டை நாங்கள் மின்னஞ்சல் செய்துள்ளோம்.</Box>
                                </Box>
                                <Button type="button" fullWidth variant="contained" color="primary" onClick={() => (navigate('/login'))} startIcon={<LoginOutlined />}>
                                    BACK TO LOGIN
                                </Button>
                            </Box>
                            : 
                            <form>
                                <Box sx={{mb:1}} className='fn-h3 fw-600 primary text-center'>Forgot password?</Box>
                                
                                <Box className='pgh text-center'><span className='fw-500'>Enter the Member ID</span> when register to recover your password. You will receive a <span className='fw-500'>password reset link.</span></Box>
                                <Box sx={{mt:"30px",display: "flex", flexDirection: "column", gap: "20px"}}>
                                    <Box sx={{display: "flex", flexDirection: "column", gap: "10px"}}>
                                        <Box sx={{ color: "black", fontWeight: 700, fontSize: { xs: "14px", sm: "16px" }, lineHeight: { xs: "14px", sm: "24px" } }}>Member ID / அங்கத்துவ எண்<span style={{color:"#EF4444"}}>*</span></Box>
                                        <TextField
                                            placeholder="e.g. 12345"
                                            fullWidth
                                            variant="outlined"
                                            onChange={(e) => setEmail(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                <InputAdornment position="start">
                                                        <RememberMeIcon />
                                                </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>

                                    <Button type="submit" fullWidth variant="contained" color="primary" onClick={handleSubmit} startIcon={<LoginOutlined />}>
                                        SEND LINK
                                    </Button>
                                </Box>
                            </form> 
                            }
                        </Box>
                    </Grid>
                </Grid>
            </Box>
    )
};